// extracted by mini-css-extract-plugin
export default {"icon":"Icon-module__icon__MXIvw"};